import React, { useEffect, useState } from 'react'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { MdTrendingDown } from 'react-icons/md'
import { Services } from '../../../../services'

export default function AlertDescontoProgressivo() {
  const { sttPg } = React.useContext(EmpresasContext)

  const [currentDesconto, setCurrentDescontoIndex] = useState(
    sttPg.selectedQuadra?.grades.filter(grade => grade.descontoProgressivo !== null) > 0 ? 0 : null,
  )

  useEffect(() => {
    const descontos = sttPg.selectedQuadra?.grades.filter(grade => grade.descontoProgressivo !== null)
    if (descontos.length > 1) {
      let currentIndex = 0
      setCurrentDescontoIndex(descontos[currentIndex])

      const interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % descontos.length
        setCurrentDescontoIndex(descontos[currentIndex])
      }, 30000)

      return () => clearInterval(interval)
    } else if (descontos.length === 1) setCurrentDescontoIndex(descontos[0])
    else setCurrentDescontoIndex(null)
  }, [sttPg.selectedQuadra])

  return (
    <>
      {currentDesconto !== null ? (
        <div className='contain-desconto-progressivo'>
          <MdTrendingDown size={30} className='icon-graphic' />
          <div className='contain-labels-desconto'>
            <p className='title-desconto-progressivo'>{`${Services.FormatValor(
              currentDesconto.descontoProgressivo.valor,
            )} de desconto ao selecionar ${Services.MinutesToHoursReduced(currentDesconto.descontoProgressivo.minimo)}`}</p>
            <p className='label-desconto-progressivo'>
              Válido das {Services.TimeStringToDate(currentDesconto.horaInicial)} às {Services.TimeStringToDate(currentDesconto.horaFinal)}
              {currentDesconto.descontoProgressivo.progressao &&
              currentDesconto.descontoProgressivo.progressao !== currentDesconto.descontoProgressivo.minimo
                ? ` ao selecionar no mínimo ${Services.MinutesToHoursReduced(currentDesconto.descontoProgressivo.minimo)}`
                : ''}
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
